import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
// import ForgotPassword from "./ForgotPassword";
import { isAuthenticated } from "../helpers/authUtils";
import LuminateLogo from "assets/images/logo.png";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import IntlMessages from "util/IntlMessages";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  hideMessage,
  showAuthLoader,
  alumniSignin,
  updateUsermode,
} from "actions/Auth";

class AlumniSignin extends React.Component {
  constructor() {
    super();
    this.state = {
      matricNo: "",
      password: "",
    };
  }
  componentDidMount() {
    this.props.updateUsermode("Alumni");
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 400);
    }
    if (isAuthenticated(this.props.authUser)) {
      this.props.history.push("/alumni/dashboard");
    }
  }
  componentDidUpdate() {
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 400);
    }
    if (isAuthenticated(this.props.authUser)) {
      this.props.history.push("/alumni/dashboard");
    }
  }

  render() {
    const { matricNo, password } = this.state;
    const { showMessage, loader, alertMessage } = this.props;
    return (
      <div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
        <div className="app-login-main-content">
          <div className="app-logo-content d-flex align-items-center justify-content-center">
            <Link className="logo-lg" to="../" title="Luminate">
              <img src={LuminateLogo} alt="FedPolyLogo" title="FedPolyLogo" />
            </Link>
          </div>

          <div className="app-login-content">
            <div className="app-login-header mb-4">
              <h1>Alumni Login</h1>
            </div>

            <div className="app-login-form">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  this.props.showAuthLoader();
                  this.props.alumniSignin({ matricNo, password });
                }}
              >
                <fieldset>
                  <TextField
                    label={`Matric Number`}
                    fullWidth
                    onChange={(event) =>
                      this.setState({ matricNo: event.target.value })
                    }
                    defaultValue={matricNo}
                    margin="normal"
                    type="text"
                    className="mt-1 my-sm-3"
                    required
                  />
                  <TextField
                    type="password"
                    label={<IntlMessages id="appModule.password" />}
                    fullWidth
                    onChange={(event) =>
                      this.setState({ password: event.target.value })
                    }
                    defaultValue={password}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    required
                  />

                  <div className="mb-3 d-flex align-items-center justify-content-between">
                    <Button
                      type="submit"
                      variant="contained"
                      style={{ backgroundColor: "#540000", color: "#ffffff" }}
                    >
                      <IntlMessages id="appModule.signIn" />
                    </Button>

                    <Link
                      to="./retrieveMatric"
                      style={{ color: "#540000" }}
                    >
                      <IntlMessages id="appModule.forgotPassword" />
                      {/* Forgot MatricNumber  */}
                    </Link>

                    <Link
                      to="./CreateAlumniAccount"
                      className="pl-1"
                      style={{ color: "#540000" }}
                    >
                      Create Account
                    </Link>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
        {loader && (
          <div className="loader-view">
            <CircularProgress />
          </div>
        )}
        {showMessage && NotificationManager.error(alertMessage)}
        <NotificationContainer />
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const { loader, alertMessage, showMessage, alumniUser } = auth;
  const authUser = alumniUser;
  return { loader, alertMessage, showMessage, authUser };
};

export default connect(mapStateToProps, {
  alumniSignin,
  hideMessage,
  showAuthLoader,
  updateUsermode,
})(AlumniSignin);
